export const LOGIN_PATH = "/login";
export const HOMEPAGE_PATH = "/";
export const CREATED_DECLARANTS_PATH = "/created";
export const DELETED_DECLARANTS_PATH = "/deleted";
export const RESET_PASSWORD_PATH = "/password/reset/:token";
export const DEPARTMENTS_DATA_PATH = "/departments-data";
export const SIGMA_PATH = "/sigma";
export const BY_CLIENTS_PATH = "/by-clients";
export const CASHBOX_PATH = "/cashbox";
export const CMR_PATH = "/cmr";
export const LOGISTIC_PATH = "/logistic";
export const CONTRACTS_PATH = "/contracts";
export const EDIT_CMR_PATH = (id: number): string => `/cmr/${id}/edit`;

export const FLEET_EXPENSES_PATH = "/fleet-expenses";

export const TOKEN_KEY = "token";
